import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    WaitForData,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/PreloadCheckoutShippingData";

export type HandlerType = Parameters<typeof WaitForData>[0];

interface TransactionData {
    event: string;
    ecommerce: {
        currency: string;
        value: number;
        customer: string | undefined;
        items: { item_name: string; item_id: string; price?: number; quantity: number }[];
    };
}

addToChainAfter(chain, WaitForData, SendBeginCheckoutTracking); // Start Checkout

function SendBeginCheckoutTracking(props: HandlerType) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        return;
    }

    const billToState = getBillToState(state, cart.billToId);

    const data: TransactionData = {
        event: "begin_checkout",
        ecommerce: {
            currency: getCurrency(cart.currencySymbol),
            value: cart.orderSubTotal,
            customer: billToState?.value?.customerNumber,
            items: [],
        },
    };

    cart.cartLines?.forEach(cartLine => {
        data.ecommerce.items.push({
            item_id: cartLine.erpNumber,
            item_name: cartLine.shortDescription,
            price: cartLine.pricing?.unitNetPrice,
            quantity: cartLine.qtyOrdered ?? 0,
        });
    });

    dataLayer.push(data);
}

function getDataLayer() {
    return (window as any).dataLayer;
}

function getCurrency(priceString: string | undefined) {
    if (priceString?.includes("$")) {
        return "USD";
    }
    return "EUR";
}
